export interface FloorplanFile {
  path: string;
  name?: string;
}

export interface BuildingListItem {
  building: string;
}

export interface LevelListItem {
  level: string | null;
}

export interface NamedItem {
  name: string;
}

export interface SuiteOption {
  label: string;
  value: string;
}

export interface BuildingEntity {
  id?: string;
  name?: string;
}

export interface LevelEntity {
  id?: string;
  name?: string;
}

export const isPdfFloorplan = (floorImage: any): boolean => {
  return !!floorImage && floorImage.includes('.pdf');
};

export const resolveFloorplanFiles = (
  floorImage: any,
  floorPlanURL: FloorplanFile[] | null
): FloorplanFile[] => {
  if (floorImage === floorPlanURL) {
    return [];
  }

  const hasViewableFloorplan =
    !!floorPlanURL &&
    floorPlanURL.length > 0 &&
    !floorPlanURL[0].path.includes('.pdf');

  if (hasViewableFloorplan) {
    return floorPlanURL as FloorplanFile[];
  }

  return [];
};

export const resolveFloorplanImage = (floorImage: any): any => {
  if (isPdfFloorplan(floorImage)) {
    return null;
  }

  return floorImage;
};

export const filterBuildingsBySearch = (
  buildingList: BuildingListItem[],
  search: string
): BuildingListItem[] => {
  if (!search) {
    return [];
  }

  const normalizedSearch = search.toLowerCase();

  return buildingList.filter((item: BuildingListItem) =>
    item.building.toLowerCase().includes(normalizedSearch)
  );
};

export const filterLevelsBySearch = (
  levelList: LevelListItem[],
  search: string
): LevelListItem[] => {
  if (!search) {
    return [];
  }

  const normalizedSearch = search.toLowerCase();

  return levelList.filter(
    (item: LevelListItem) =>
      !!item.level && item.level.toLowerCase().includes(normalizedSearch)
  );
};

export const toNameOptions = (
  items: NamedItem[] | null | undefined
): SuiteOption[] => {
  if (!items || items.length === 0) {
    return [];
  }

  return items.map((item: NamedItem) => ({
    label: item.name,
    value: item.name,
  }));
};

export const keyFobsNeedLabels = (keyFobs: any[]): boolean => {
  return keyFobs.some((fob: any) => !fob.label || !fob.value);
};

export const withKeyFobLabels = (keyFobs: any[]): any[] => {
  return keyFobs.map((fob: any) => ({
    ...fob,
    label: fob.name,
    value: fob.name,
  }));
};

export const resolveBuildingInputValue = (
  isChanged: boolean,
  building: BuildingEntity | null | undefined,
  buildingName: string | undefined
): string | undefined => {
  if (isChanged) {
    return buildingName;
  }

  if (building && building.id) {
    return building.name;
  }

  return buildingName;
};

export const resolveLevelInputValue = (
  isLevelChanged: boolean,
  level: LevelEntity | null | undefined,
  levelName: string | undefined
): string | undefined => {
  if (isLevelChanged) {
    return levelName;
  }

  if (level && level.id) {
    return level.name;
  }

  return levelName;
};

export const mapFormAreas = (areas: any[]): any[] => {
  return areas.map((item: any) => ({
    id: item.areaId,
    customLabel: item.customLabel,
    name: item.name,
  }));
};
